import React from "react";
import "./style.scss";
import { IoTime } from "react-icons/io5";
import { Exercise } from "../../../models/Exercise";
import getId from "../../../../utils/getId";
import { BiErrorCircle } from "react-icons/bi";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { TICKETS_PAGE } from "../../../routes";
import ButtonCustom from "../../../../features/ButtonCustom/ButtonCustom";
import { useNavigate } from "react-router";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import { CHANGE_ZONE_SELECT_TO_LIMITED } from "../../../api/apiRoutes";
import { formatDateToTime } from "../../../../utils/formatDateToTime";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import useConfigDiscount from "../../../../utils/hooks/useConfigDiscount";

interface IProps {
  exerciseList: Exercise[];
  onSelect: (exercise: Exercise) => void;
  select: Exercise | null;
  setSelect: (value: Exercise | null) => void;
}

const ExerciseSelect: React.FC<IProps> = ({ exerciseList, onSelect, select, setSelect }: IProps) => {
  const navigate = useNavigate();
  const { post } = useApiRequest();
  const isDesktop = useDesktopSize();

  const getClassSelect = (item: Exercise) => (getId(select) === getId(item) ? "active-exercise" : "");
  const getClassBanner = (item: Exercise) =>
    getId(select) === getId(item) ? "promotion-banner-active" : "promotion-banner";
  const exerciseLimit = select ? select.capacity - select.reserved - select.prereservation : 0;
  const { DISCOUNT, DISCOUNT_TEXT } = useConfigDiscount();

  const calculateLimit = (value: Exercise): number => {
    return value.capacity - value.reserved - value.prereservation;
  };

  const handleExercise = (value: Exercise) => {
    setSelect(value);
    onSelect(value);
  };

  const changeZone = async () => {
    const { isError } = await post(CHANGE_ZONE_SELECT_TO_LIMITED);
    if (!isError) {
      navigate(`${TICKETS_PAGE}?isSaleWithExercise=false&isChangeZone=true`);
    }
  };

  const isPromotionText = () => {
    return exerciseList.some((item: Exercise) => item.julinekDiscount);
  };

  return (
    <div className={"panel-exercise"}>
      <p className={"title"}>Wybierz przedział czasowy</p>
      {isPromotionText() && <p className={"second-text"}>Bilety z drugiego przedziału są tańsze o {DISCOUNT}!</p>}
      <div className={"exercise-list-wrapper"}>
        {exerciseList.map((item: Exercise, index: number) =>
          calculateLimit(item) > 0 ? (
            <div key={index} className={`exercise-div ${getClassSelect(item)}`} onClick={() => handleExercise(item)}>
              <p>{item.name}</p>
              <span>
                <IoTime className={`second-color ${getClassSelect(item)}`} />
              </span>
              <p>{`od ${formatDateToTime(item.startTime)}`}</p>
              {item.julinekDiscount && <p className={`${getClassBanner(item)}`}>{DISCOUNT_TEXT}</p>}
            </div>
          ) : (
            <div key={index} className={"exercise-div-no-limit"}>
              <p>Limit biletów popołudniowych został wyczerpany.</p>
              <p>
                Kup bilet w kasie lub wybierz bilet online w strefie zielonej, a następnie rozszerz go gdy w Parku
                Wodnym zwolni się miejsce.
              </p>
              <ButtonCustom
                title={"Zmień strefę"}
                className={`button-first-color`}
                Icon={HiOutlineArrowNarrowRight}
                iconPosition={"right"}
                onClick={() => changeZone()}
              />
            </div>
          )
        )}
        {select && exerciseLimit > 0 && (
          <div className={"exercise-limit"}>
            <span>
              <BiErrorCircle size={24} />
            </span>
            {isDesktop ? (
              <>
                <p className={"textLimit1"}>W tym przedziale obowiązuje limit wejść.</p>
                <p className={"textLimit2"}>{`Pozostało ${exerciseLimit} osób.`}</p>
              </>
            ) : (
              <p
                className={"textLimit1"}
              >{`W tym przedziale obowiązuje limit wejść. Pozostało ${exerciseLimit} osób.`}</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExerciseSelect;
